import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Paper, Typography, Divider } from '@mui/material'

interface IProductionInstructionContentCardProps {
  children: React.ReactNode
}

/**
 * ProductionInstructionContentCard Page
 *
 * @param __namedParameters IProductionInstructionContentCardProps
 * @returns JSX.Element
 * @category ReactComponents
 */
export const ProductionInstructionContentCard: React.FC<IProductionInstructionContentCardProps> = ({
  children,
}): JSX.Element => {
  const { t } = useTranslation()
  return (
    <Paper>
      <Box padding={2}>
        <Typography
          component={'h3'}
          variant="h6"
          sx={{
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '20px',
            lineHeight: '32px',
            letterSpacing: '0.15px',
          }}
        >
          {t('production_instructions.production_content')}
        </Typography>
      </Box>
      <Divider />
      <Box width={'100%'} paddingBottom={2}>
        {children}
      </Box>
    </Paper>
  )
}
